import Media from 'react-media';
import { CaretLeft } from '@phosphor-icons/react';
import { Heading, breakpoints } from '@etg/wings';
import { css, cx, resetButtonStyle } from '@eti/styles';
import { useEffect, useRef } from 'react';
import { useTranslation } from '@eti/providers';
import { OverlayHeader, getCloseButtonStyles, headerWrapperStyles } from './OverlayComponents';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const headContainerStyle = css`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;
const buttonStyle = css`
  position: relative;
`;
const headStyle = css`
  line-height: normal;
`;
export const OverlayHeaderWithBackButton = _ref => {
  let {
    ariaLabel,
    className,
    dialogCloseButtonAriaLabel,
    onClose,
    journeyType,
    title
  } = _ref;
  const {
    t
  } = useTranslation();
  const buttonref = useRef(null);
  useEffect(() => {
    if (buttonref.current) {
      buttonref.current.focus();
    }
  }, []);
  return /*#__PURE__*/_jsx(Media, {
    query: `(min-width: ${breakpoints._768})`,
    children: matches => matches ? /*#__PURE__*/_jsx(OverlayHeader, {
      onClose: onClose,
      title: title
    }) : /*#__PURE__*/_jsxs("header", {
      className: cx(headerWrapperStyles, className),
      children: [onClose && /*#__PURE__*/_jsx("button", {
        "aria-label": dialogCloseButtonAriaLabel !== null && dialogCloseButtonAriaLabel !== void 0 ? dialogCloseButtonAriaLabel : t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
        className: cx(resetButtonStyle, getCloseButtonStyles, buttonStyle),
        "data-testid": "overlay-close",
        onClick: onClose,
        ref: buttonref,
        type: "button",
        children: /*#__PURE__*/_jsx(CaretLeft, {
          "aria-hidden": true,
          size: 24,
          weight: "light"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: headContainerStyle,
        children: [/*#__PURE__*/_jsx(Heading, {
          "aria-label": ariaLabel,
          className: headStyle,
          level: 2,
          children: title
        }), journeyType]
      })]
    })
  });
};
//# sourceMappingURL=OverlayComponentsBackButton.js.map